import { PiChefHatFill } from "react-icons/pi";
import { FaCircleCheck, FaCircleXmark } from "react-icons/fa6";
import i18n from "i18next";
import { showToast } from "./ShowToast";
import socket from "@/utils/socket";
import { ReceiveOrderType } from "@/config";

export const handleSocketStatusProductIn = (
    event: string,
    sound: HTMLAudioElement,
    isAdmin: boolean
) => {
    const listener = (data: ReceiveOrderType) => {
        if (!localStorage.getItem("token")) return;
        if (data) {
            const status: Record<number, string> = {
                2: i18n.t("hasBeenRejected"),
                4: i18n.t("hasBeenCooking"),
                5: i18n.t("cookingReady")
            }

            const iconStatus: Record<number, JSX.Element> = {
                2: <FaCircleXmark size={24} style={{ color: "#DF5252" }} />,
                4: <PiChefHatFill size={24} style={{ color: "#FDC040" }} />,
                5: <FaCircleCheck size={24} style={{ color: "#52DF77" }} />,
            }
            if (isAdmin) {
                sound?.play?.()?.catch?.(() => {});
                const items = Array.isArray(data.data) ? data.data : (data.data ? [data.data] : []);
                items.forEach(({ productName, productNameKH, name, nameKH }: any) => {
                    const message = status[data.status];
                    const icon = iconStatus[data.status];

                    showToast(message, productName || name, icon, { reverse: true }, productNameKH || nameKH);
                });
            } else {
                sound?.play?.()?.catch?.(() => {});
                const items = Array.isArray(data.data) ? data.data : (data.data ? [data.data] : []);
                items.forEach(({ productName, productNameKH, name, nameKH }: any) => {
                    if (data.status !== 5) {
                        const message = status[data.status];
                        const icon = iconStatus[data.status];

                        showToast(message, productName || name, icon, { reverse: true }, productNameKH || nameKH);
                    }
                });
            }
        }
    };

    socket.on(event, listener);

    return () => {
        socket.off(event, listener);
    };
};
